import { render, staticRenderFns } from "./ChatsList.vue?vue&type=template&id=58b4af10"
import script from "./ChatsList.vue?vue&type=script&lang=js"
export * from "./ChatsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports